import React from "react";
import { formatDateTime } from "../../../utils/date";
import ClientInfoComponent from "../../../components/Repetitive_components/clientInfoComponent";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { have_product_reference } from "../../../helpers/OrdersFunctionsGlobal";
import { GoPrimitiveDot } from "react-icons/go";
import {
  returnEuroString,
  antdMessageSuccess,
  antdMessageError,
  exportDocument,
} from "../../../helpers/Utils";
import { colors } from "../../../utils/colors";
import CourierLinksComponent from "../../../components/Repetitive_components/courierLinksComponent";
import { Checkbox, Popover } from "antd";
import RenderSms from "../components/RenderSms";
import { useMutation } from "react-query";
import Axios from "axios";
import { ButtonSecondary, TextInput } from "../../../components/globals";
import { MdEdit } from "react-icons/md";
import { BsFillXCircleFill } from "react-icons/bs";
import { FaCheckCircle } from "react-icons/fa";
import { usePickupState } from "../../../context/PickupContext";

export default function PickupIndexColumns({ e, refetch, setShowOrderModal }) {
  const {
    customer,
    order_date,
    billing_address = {},
    comments = [],
    remark: note_from_client,
  } = e.order;
  const [checkedAll, setCheckedAll] = React.useState(false);
  const [checkedBoxes, setCheckedBoxes] = React.useState([]);
  const [showPrepared, setShowPrepared] = React.useState(false);
  const [selectedStatus, setSelectedStatus] = React.useState(null);
  const [shipmentOrderRowIds, setShipmentOrderRowIds] = React.useState("");
  const [innerDocument, setInnerDocument] = React.useState(
    e.inner_doc_number || ""
  );
  const [isEditInnerDocument, setIsEditInnerDocument] = React.useState(false);
  const { user } = usePickupState();
  const PickupStatus = {
    UNPREPARED: "unprepared",
    CLIENT_CALLED: "client_called",
    PREPARED: "prepared",
    GIVE_AWAY: "give_away",
    CANCELED: "canceled",
    WANTS_TO_CANCEL: "wants_to_cancel",
  };
  const renderRivilesNumbers = () => {
    let array = comments
      .filter((e) => e.com_state === "Siunčiama" && numberCheckERS(e.body))
      .map((e) => numberCheckERS(e.body));

    if (e.invoice_number) {
      array = [...new Set([...array, e.invoice_number])];
    } else {
      array = [...new Set(array)];
    }

    return (
      <div className="row m-0">
        {array.map((e) => (
          <div
            key={e}
            className="badge badge-pill badge-success mr-2 mb-1 text-black editInputForm"
          >
            {e}
          </div>
        ))}
      </div>
    );
  };

  const productStatus = (status) => {
    switch (status) {
      case PickupStatus.UNPREPARED:
        return "Nesuruošta";
      case PickupStatus.CLIENT_CALLED:
        return "Iškviestas klientas";
      case PickupStatus.PREPARED:
        return "Suruošta";
      case PickupStatus.GIVE_AWAY:
        return "Atiduota";
      case PickupStatus.CANCELED:
        return "Atšauktas";
      case PickupStatus.WANTS_TO_CANCEL:
        return "Klientas nori atšaukti";
      default:
        return "Nesuruošta";
    }
  };
  const mutationPUTProductStatus = useMutation({
    mutationFn: (products) =>
      Axios({
        url: `/pickups/requests/update_rows_status`,
        method: "PUT",
        params: {
          status: products.status,
          ids: products.ids,
        },
      }).then((res) => res.data),
    onSuccess: () => {
      antdMessageSuccess();
      refetch();
    },
    onError: (error) => antdMessageError(error?.response?.data?.message),
  });

  const mutationPUTPickupRow = useMutation({
    mutationFn: (value) =>
      Axios({
        url: `/pickups/requests/update_pickup`,
        method: "PUT",
        params: {
          inner_doc_number: value.inner_doc_number,
          id: value.id,
        },
      }).then((res) => res.data),
    onSuccess: () => {
      antdMessageSuccess();
      refetch();
    },
    onError: (error) => antdMessageError(error?.response?.data?.message),
  });

  const getCheckedIds = (shipmentId) => {
    const checkedIds = [];
    for (const itemId in checkedBoxes[shipmentId]) {
      if (checkedBoxes[shipmentId][itemId]) {
        checkedIds.push(itemId);
      }
    }
    return checkedIds;
  };

  const unselectAllCheckboxes = (shipmentId) => {
    setCheckedBoxes((prevCheckedBoxes) => ({
      ...prevCheckedBoxes,
      [shipmentId]: {},
    }));
    setCheckedAll(false);
  };

  const onCancelHandler = (shipmentId) => {
    const checkedIds = getCheckedIds(shipmentId);
    if (checkedIds.length > 0) {
      mutationPUTProductStatus.mutate({
        ids: checkedIds,
        status: PickupStatus.CANCELED,
      });
      unselectAllCheckboxes(shipmentId);
      setSelectedStatus(null);
    }
  };

  const onGivenHandler = (shipmentId) => {
    const checkedIds = getCheckedIds(shipmentId);
    if (checkedIds.length > 0) {
      mutationPUTProductStatus.mutate({
        ids: checkedIds,
        status: PickupStatus.GIVE_AWAY,
      });
      unselectAllCheckboxes(shipmentId);
      setSelectedStatus(null);
    }
  };

  const onGivenWithoutSmsHandler = (shipmentId) => {
    const checkedIds = getCheckedIds(shipmentId);
    if (checkedIds.length > 0) {
      mutationPUTProductStatus.mutate({
        ids: checkedIds,
        status: PickupStatus.GIVE_AWAY,
      });
      unselectAllCheckboxes(shipmentId);
      setSelectedStatus(null);
    }
  };

  const onSummonCustomerlHandler = (shipmentId) => {
    const checkedIds = getCheckedIds(shipmentId);
    if (checkedIds.length > 0) {
      refetch();
      unselectAllCheckboxes(shipmentId);
      setSelectedStatus(null);
    }
  };

  const onPreparedHandler = (shipmentId) => {
    const checkedIds = getCheckedIds(shipmentId);
    if (checkedIds.length > 0) {
      mutationPUTProductStatus.mutate({
        ids: checkedIds,
        status: PickupStatus.PREPARED,
      });
      unselectAllCheckboxes(shipmentId);
      setSelectedStatus(null);
    }
  };

  const handleCheckboxChange = (event, shipmentId, itemId, pickupStatus) => {
    setCheckedBoxes((prev) => {
      const updated = {
        ...prev,
        [shipmentId]: {
          ...(prev[shipmentId] || {}),
          [itemId]: event.target.checked,
        },
      };

      const currentItemOrderRowId = arrangedRows.find(
        (item) => item.id === itemId
      )?.order_row.id;

      if (event.target.checked) {
        const childItems = arrangedRows.filter(
          (item) =>
            item.shipment_id === shipmentId &&
            item.order_row.parent_id === currentItemOrderRowId
        );
        childItems.forEach((child) => {
          updated[shipmentId][child.id] = true;
        });
      }

      // If a parent item is unchecked, also uncheck its child items
      if (!event.target.checked) {
        const childItems = arrangedRows.filter(
          (item) =>
            item.shipment_id === shipmentId &&
            item.order_row.parent_id === currentItemOrderRowId
        );
        childItems.forEach((child) => {
          updated[shipmentId][child.id] = false;
        });
      }

      const allUnchecked = !Object.values(updated).some((shipment) =>
        Object.values(shipment).some((checked) => checked)
      );

      if (allUnchecked) {
        setSelectedStatus(null);
      } else if (selectedStatus === null) {
        setSelectedStatus(pickupStatus);
      }

      return updated;
    });
  };

  const handleCheckAllChange = (event, shipmentId, shipmentOrderRows) => {
    const isChecked = event.target.checked;
    setCheckedAll(isChecked);
    console.log(shipmentOrderRows, "shipmentOrderRows");
    setSelectedStatus(
      isChecked && shipmentOrderRows.length > 0
        ? shipmentOrderRows[0].pickup_status
        : null
    );
    const newCheckedBoxes = { ...checkedBoxes };
    newCheckedBoxes[shipmentId] = {};
    shipmentOrderRows.forEach((item) => {
      newCheckedBoxes[shipmentId][item.id] = isChecked;
    });
    setCheckedBoxes(newCheckedBoxes);
  };

  const isAnyCheckboxChecked = (shipmentId) => {
    return Object.values(checkedBoxes[shipmentId] || {}).some(Boolean);
  };

  const shipmentId = e?.shipment?.shipment_order_rows?.[0]?.shipment_id;

  const onExportDocumentClick = () => {
    exportDocument(
      `/pickups/requests/download_pickup_at_store?shipment_id=${shipmentId}&shipment_order_row_ids=` +
      shipmentOrderRowIds,
      `pickup_at_store${e.id}.pdf`,
      "POST"
    );
  };

  const getCheckedItemIds = (shipmentId) => {
    const shipment = checkedBoxes[shipmentId];
    if (!shipment) {
      return [];
    }

    return Object.keys(shipment).filter((itemId) => shipment[itemId]);
  };

  const allCheckedHaveStatus = (shipmentId, requiredStatuses) => {
    if (!checkedBoxes[shipmentId]) {
      return false;
    }

    const checkedIds = Object.keys(checkedBoxes[shipmentId]).filter(
      (id) => checkedBoxes[shipmentId][id]
    );

    if (checkedIds.length === 0) {
      return false;
    }

    if (!requiredStatuses?.includes(selectedStatus)) {
      return false;
    }

    return true;
  };

  const isAnyChecked = isAnyCheckboxChecked(shipmentId);
  const isExportDocumentAvailable = e.shipment?.shipment_order_rows.some(
    (row) =>
      typeof row.pickup_status === "string" &&
      row.pickup_status !== PickupStatus.UNPREPARED
  );

  const RenderButton = ({ className, onClick, children, requiredStatuses }) => (
    <button
      className={`btn btn-sm float-left mr-1 ${className}`}
      onClick={onClick}
      disabled={
        !isAnyChecked ||
        (requiredStatuses &&
          !allCheckedHaveStatus(shipmentId, requiredStatuses))
      }
    >
      {children}
    </button>
  );

  const setInnerComponenet = (value, id) => {
    refetch();
    setIsEditInnerDocument(false);
    mutationPUTPickupRow.mutate({ inner_doc_number: value, id });
  };

  React.useEffect(() => {
    if (checkedBoxes.length !== 0) {
      const shipmentOrderRowIdsArray = Object.keys(
        checkedBoxes[shipmentId]
      ).filter((key) => checkedBoxes[shipmentId][key]);
      setShipmentOrderRowIds(() => shipmentOrderRowIdsArray.join(","));
    }
  }, [checkedBoxes]);

  const arrangeRows = (shipment_order_rows) => {
    const arrangedRows = [];
    let parentRows, childRows;

    parentRows = shipment_order_rows.filter(
      (item) => item.order_row?.product_reference !== "{}"
    );

    childRows = shipment_order_rows.filter(
      (item) =>
        item.order_row?.parent_id !== null &&
        item.order_row?.product_reference === "{}"
    );

    parentRows = parentRows.map((parent) => ({
      ...parent,
      order_row: { ...parent.order_row, isParent: true },
    }));

    childRows = childRows.map((child) => ({
      ...child,
      order_row: { ...child.order_row, isParent: false },
    }));

    parentRows.forEach((parent) => {
      arrangedRows.push(parent);
      childRows.forEach((child) => {
        if (child.order_row.parent_id === parent.order_row.id) {
          arrangedRows.push(child);
        }
      });
    });

    return arrangedRows;
  };

  // Use the new function
  const arrangedRows = arrangeRows(e.shipment?.shipment_order_rows);
  return (
    <tr>
      <td className="align-middle">
        <small>{formatDateTime(e.created_at)}</small>
      </td>
      <td className="align-middle">
        <small>{formatDateTime(order_date)}</small>
      </td>
      <td
        className={`align-middle ${[
          e.order.shipping_address.street2,
          e.order.billing_address.street2,
        ].includes("express")
          ? "text-danger"
          : ""
          }`}
      >
        <div
          className="text-decoration-underline text-black font-semi-bold text-xs cursor-pointer"
          onClick={() => setShowOrderModal(e.id)}
        >
          {e.order.id_order}
        </div>
        {e.status == PickupStatus.UNPREPARED &&
          [
            e.order.shipping_address.street2,
            e.order.billing_address.street2,
          ].includes("express") && (
            <MiniTimeTracking number={e.seconds_before_deadline} />
          )}
      </td>
      <td className="align-middle">
        <ClientInfoComponent
          client={billing_address}
          customer={customer}
          note_from_client={
            note_from_client || e.shipment.shipment_address?.comment
          }
          order_shop={e?.order?.carrier?.order_shop}
          shipping_address={e?.shipment?.shipment_address}
        />
      </td>
      <td className="align-middle" style={{ width: "30%" }} colSpan={2}>
        <Checkbox
          className="ml-1"
          checked={checkedAll}
          onChange={(event) => {
            handleCheckAllChange(
              event,
              shipmentId,
              e.shipment.shipment_order_rows
            );
          }}
          disabled={
            e.shipment.shipment_order_rows.some(
              (item) => item.pickup_status === PickupStatus.CANCELED
            ) ||
            [
              ...new Set(
                e.shipment.shipment_order_rows.map(
                  (item) => item.pickup_status || PickupStatus.UNPREPARED
                )
              ),
            ].length > 1
          }
        >
          <p className={checkedAll ? "text-color-black" : "text-color-grey"}>
            Pažymėti visas
          </p>
        </Checkbox>
        <table style={{ width: "100%" }}>
          <tbody>
            {arrangedRows.map((item) => {
              const pickupStatus =
                item.pickup_status || PickupStatus.UNPREPARED;
              const disabled =
                pickupStatus !== selectedStatus && selectedStatus !== null;
              const productReference = item.order_row?.product_reference;
              const hasProductReference =
                productReference && have_product_reference(productReference);
              const quantity = parseInt(
                item.quantity || item.order_row?.quantity
              );
              const title = item.title || item.order_row?.product_name;
              const requiresSerialNumber =
                item.order_row?.required_serial_number &&
                !item.order_row?.serial_number;
              const isChildRow = item.order_row?.isParent === false;

              return (
                <React.Fragment key={item.id}>
                  <tr
                    className="border-top-grey d-flex justify-content-between"
                    style={
                      isChildRow
                        ? { borderTop: "none", marginRight: "-5px" }
                        : { marginRight: "-5px" }
                    }
                  >
                    <td className="d-flex align-items-center justify-content-center">
                      {!isChildRow ? (
                        <Checkbox
                          className="mr-1"
                          checked={checkedBoxes[shipmentId]?.[item.id] || false}
                          onChange={(event) =>
                            handleCheckboxChange(
                              event,
                              shipmentId,
                              item.id,
                              pickupStatus
                            )
                          }
                          disabled={
                            disabled ||
                            item.pickup_status === PickupStatus.CANCELED
                          }
                        />
                      ) : (
                        <div style={{ width: 22 }} />
                      )}
                      <span className="text-black font-medium d-flex align-items-center">
                        {quantity}
                        &nbsp;*&nbsp;
                        {hasProductReference ? (
                          productReference
                        ) : (
                          <AiOutlineCheckCircle className="text-success mr-1" />
                        )}
                        &nbsp;
                        <span
                          className={
                            item.order_row?.manual
                              ? null
                              : "border-bottom border-danger"
                          }
                        >
                          {title}
                        </span>
                      </span>
                      {requiresSerialNumber && (
                        <>
                          <br />
                          <span className="text-danger">Reikalingas S/N</span>
                        </>
                      )}
                    </td>
                    {!isChildRow && (
                      <td className="align-flex-center pickup-status-container">
                        <div className="text-sm text-black">
                          {productStatus(pickupStatus)}
                        </div>
                        <CourierLinksComponent shipments={[e.shipment]} />
                      </td>
                    )}
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
        <div>
          {isAnyChecked &&
            (selectedStatus === PickupStatus.UNPREPARED ||
              selectedStatus === PickupStatus.PREPARED) ? (
            <Popover
              placement="bottom"
              onOpenChange={(val) => setShowPrepared(val)}
              onClick={() => setShowPrepared((prev) => !prev)}
              open={showPrepared}
              content={
                showPrepared ? (
                  <RenderSms
                    id={e.id}
                    enableOnSendSmSClick={true}
                    onSendSmSClick={() => onSummonCustomerlHandler(shipmentId)}
                    checkedIds={getCheckedIds(shipmentId)}
                    phoneNumber={billing_address.phone}
                    shipping_address_street={`${e.shipment.shipment_address.address}, ${e.shipment.shipment_address.city}`}
                    orderId={e.order.id_order}
                    shipments={e.shipment.shipment_order_rows}
                    sms_sendings={[]}
                    chekedItemsId={getCheckedItemIds(shipmentId)}
                    mode="Simple"
                    closePopover={() => setShowPrepared(false)}
                  />
                ) : null
              }
            >
              <RenderButton
                requiredStatuses={[
                  PickupStatus.UNPREPARED,
                  PickupStatus.PREPARED,
                ]}
                className="btn-outline-warning btn-outline-orange call-client-button"
              >
                Suruošta
              </RenderButton>
            </Popover>
          ) : (
            <RenderButton
              requiredStatuses={[
                PickupStatus.UNPREPARED,
                PickupStatus.PREPARED,
              ]}
              className="btn-outline-warning btn-outline-orange call-client-button"
            >
              Suruošta
            </RenderButton>
          )}

          <RenderButton
            requiredStatuses={[
              PickupStatus.CLIENT_CALLED,
              ...(user?.can_handover_without_prepared
                ? [PickupStatus.UNPREPARED, PickupStatus.PREPARED]
                : []),
            ]}
            className="btn-outline-warning btn-outline-orange"
            onClick={() => onGivenHandler(shipmentId)}
          >
            Atiduota
          </RenderButton>

          {user?.is_admin && (
            <RenderButton
              requiredStatuses={[PickupStatus.PREPARED]}
              className="btn-outline-success btn-outline-green"
              onClick={() => onGivenWithoutSmsHandler(shipmentId)}
            >
              Atiduota be SMS
            </RenderButton>
          )}

          {user?.is_admin && (
            <RenderButton
              requiredStatuses={[
                PickupStatus.PREPARED,
                PickupStatus.UNPREPARED,
                PickupStatus.CLIENT_CALLED,
              ]}
              className="btn-danger h-29"
              onClick={() => onCancelHandler(shipmentId)}
            >
              Atšaukti
            </RenderButton>
          )}

          {isExportDocumentAvailable && (
            <ButtonSecondary
              style={{ width: "auto" }}
              className="btn btn-sm btn-primary mr-2"
              onClick={onExportDocumentClick}
              disabled={
                !isAnyChecked ||
                allCheckedHaveStatus(shipmentId, [PickupStatus.UNPREPARED])
              }
              bgColor={colors["orange"]}
              bgActiveColor={colors["orange"]}
            >
              Atidavimo dokumentas
            </ButtonSecondary>
          )}
        </div>
        {renderRivilesNumbers()}
      </td>

      <td className="align-middle">
        {e.shipment?.shipment_address && (
          <div className="d-flex py-1 px-2">
            <div className="d-flex justify-content-center align-items-center mr-1">
              <GoPrimitiveDot
                size={10}
                style={{
                  color: colors["technorama"],
                }}
              />
            </div>
            <div
              style={{
                color: colors["technorama"],
              }}
            >
              <small>
                {e.shipment.shipment_address.address}
                {", "}
                {e.shipment.shipment_address.postal_code}
                {", "}
                {e.shipment.shipment_address.city}
              </small>
            </div>
          </div>
        )}
      </td>
      <td className="align-middle">
        <small>{e.order.payment}</small>
      </td>
      <td className="align-middle my-td">
        {isEditInnerDocument ? (
          <div className="my-flex-div">
            <div className="my-input-div">
              <TextInput
                type="text"
                placeholder="Vidinis numeris"
                value={innerDocument}
                name="inner_document"
                onChange={(e) => setInnerDocument(e.target.value)}
              />
            </div>
            <FaCheckCircle
              className="my-icon mb-10px"
              color="#28A745"
              onClick={() => {
                setInnerComponenet(innerDocument, e.id);
              }}
            />
            <BsFillXCircleFill
              className="my-icon mb-10px"
              color="#C94747"
              onClick={() => {
                setIsEditInnerDocument(false);
              }}
            />
          </div>
        ) : (
          <div
            onClick={() => {
              setIsEditInnerDocument(true);
            }}
          >
            <div className="d-flex flex-row align-items-center">
              <div
                className="d-flex flex-column"
                style={{ width: 100, maxWidth: 100 }}
              >
                <small>{innerDocument || "Neįvesta"}</small>
                <small style={{ fontSize: 9, color: "#727272" }}>
                  {e.inner_doc_date}
                </small>
              </div>
              <MdEdit color="#5F5F5F" className="my-icon" />
            </div>
          </div>
        )}
      </td>
      <td className="align-middle">
        <small>{e.shipment.pickup_address || ""}</small>
      </td>
      <td className="align-middle">
        <div className="d-flex">
          {returnEuroString(
            e.shipment?.shipment_order_rows?.reduce(
              (cur, acc) =>
                (+acc.price || acc.order_row?.product_price || 0) *
                (+acc.quantity || +acc.order_row?.quantity || 0) +
                cur,
              0
            )
          )}
        </div>
      </td>
    </tr>
  );
}
